import { render, staticRenderFns } from "./InfoHeader.vue?vue&type=template&id=49b7c192&scoped=true&"
import script from "./InfoHeader.vue?vue&type=script&lang=js&"
export * from "./InfoHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b7c192",
  null
  
)

export default component.exports